interface FeatureCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  descriptionColor?: string;
  accent?: "indigo" | "emerald" | "amber" | "brand";
}

const accents = {
  indigo: "from-indigo-500 to-violet-600",
  emerald: "from-emerald-500 to-teal-600",
  amber: "from-amber-400 to-orange-500",
  brand: "from-[#cd212a] to-[#2e436a]",
};

export default function FeatureCard({
  icon,
  title,
  description,
  descriptionColor = "text-secondary",
  accent = "brand",
}: FeatureCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-secondary/10 bg-white p-5 shadow-lg shadow-secondary/5 transition hover:-translate-y-0.5 hover:shadow-xl text-left">
      <div
        className={`absolute -right-4 -top-4 h-16 w-16 rounded-full bg-gradient-to-br ${accents[accent]} opacity-10 blur-xl transition group-hover:opacity-20`}
      />
      <div className="relative">
        {icon && <div className="mb-2 text-2xl">{icon}</div>}
        <p className="text-[11px] font-bold uppercase tracking-wider text-secondary/50">{title}</p>
        <p className={`mt-1 text-3xl font-extrabold tabular-nums ${descriptionColor}`}>
          {description}
        </p>
      </div>
    </div>
  );
}
